import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

const Categories = {
  Poor: 'poor',
  Mediocre: 'mediocre',
  Good: 'good',
};

const Indicators = {
  [Categories.Poor]: '⬇',
  [Categories.Mediocre]: '―',
  [Categories.Good]: '⬆',
};

const ratingToCategory = (rating) => {
  if (rating < 0) return Categories.Poor;
  if (rating < 20) return Categories.Mediocre;
  return Categories.Good;
};

export default function RatingCard({
  rating,
}) {
  const category = ratingToCategory(rating);
  return (
    <div
      className={classNames(
        Styles.mainContainer,
        {
          [Styles.mainContainerGood]: category === Categories.Good,
          [Styles.mainContainerMediocre]: category === Categories.Mediocre,
          [Styles.mainContainerPoor]: category === Categories.Poor,
        },
      )}
    >
      <div className={Styles.rateContainer}>{`${rating === 0 ? '資料不足' : `${rating > 0 ? `+${rating.toFixed(2)}` : rating.toFixed(2)}%`}`}</div>
      <div
        className={classNames(
          Styles.indicatorContainer,
          {
            [Styles.indicatorContainerGood]: category === Categories.Good,
            [Styles.indicatorContainerMediocre]: category === Categories.Mediocre,
            [Styles.indicatorContainerPoor]: category === Categories.Poor,
          },
        )}
      >
        {Indicators[category]}
      </div>
    </div>
  );
}

RatingCard.propTypes = {
  rating: PropTypes.number,
};

RatingCard.defaultProps = {
  rating: 0,
};
